module.exports = __webpack_public_path__ + "img/tik.171b1f4c.svg";